import { useLocation } from 'react-router-dom'
import { colors, size } from '@styles/theme'
import styled from '@emotion/styled'

import { TbSquare, TbSquareCheck } from 'react-icons/tb'
import { ZoomableImage } from '@elements/ZoomableImage'
import ModalContainer from '@elements/ModalContainer'
import { ButtonBase } from '@mui/material'

const SelectButton = styled(ButtonBase)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: ${size(6)};

  display: flex;
  align-items: center;
  justify-content: center;
  
  padding: 0 ${size(3)};
  height: ${size(5)};
  width: ${size(19)};
  border-radius: 100px;
  
  font-weight: 600;
  text-shadow: 0 1px 4px #333333CC;
  box-shadow: 0 1px 4px 2px #333333CC;
  
  svg {
    filter: drop-shadow(0 0.5px 2px #333333CC);
  }
`

const SelectedNumber = styled.div`
  position: absolute;
  right: ${size(0.25)};
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: center;

  height: ${size(4.5)};
  width: ${size(4.5)};
  border-radius: 100px;

  background-color: #333333CC;
  font-weight: 800;
`

const NumberClearfix = styled.div`
  width: ${size(3)};
`

const UserMediaViewer = ({ isOpen, selectedState, addSelected, removeSelected }) => {
  const location = useLocation()
  const { image } = location?.state ?? {}
  const isSelected = image.uuid in selectedState.index
  const selectedIndex = selectedState?.index?.[image.uuid]

  const handleSelectClick = () => {
    if (isSelected) {
      removeSelected(image)
    } else {
      addSelected(image)
    }
  }

  return (
    <ModalContainer open={isOpen}>
      <ZoomableImage src={image?.url} />
      <SelectButton
        style={{ backgroundColor: isSelected ? colors.statusColors.right_now('light') : 'grey' }}
        onClick={handleSelectClick}>
        {isSelected
          ? <TbSquareCheck strokeWidth={size(0.3)} size={size(2)} />
          : <TbSquare strokeWidth={size(0.3)} size={size(2)} />
        }
        &nbsp;
        {isSelected ? `Selected` : 'Unselected'}
        {isSelected && (
          <>
            <SelectedNumber>{selectedIndex + 1}</SelectedNumber>
            <NumberClearfix />
          </>
        )}
      </SelectButton>
    </ModalContainer>
  )
}

export { UserMediaViewer }
